import { FaqGroup } from './faq-group.model';
import { Question } from './question.model';

export class FaqCollection {
    public faqGroups: FaqGroup[] = [];

    public popularFaqs: Question[] = [];
}
